import { gql } from "@apollo/client"
import { useMutation, InjectedOptions } from "@oysterhr/core"
import { GENERAL_STAFF_GET_CUSTOMER_EQUITY_TAB } from "../EquityTab"

const CREATE_EQUITY_COMPANY_PLAN_QUERY = gql`
  mutation CreateEquityCompanyPlan(
    $companyId: ID!
    $planName: String
    $grantorName: String
    $vestingScheduleMonths: Int
    $vestingCliffMonths: Int
    $vestingCliffShares: Float
    $equityManagementSoftwareName: [String!]
    $contactPersonName: String
    $contactPersonEmail: String
    $contactPersonJobTitle: String
  ) {
    equityCreateCompanyPlan(
      input: {
        companyId: $companyId
        planName: $planName
        grantorName: $grantorName
        vestingScheduleMonths: $vestingScheduleMonths
        vestingCliffMonths: $vestingCliffMonths
        vestingCliffShares: $vestingCliffShares
        equityManagementSoftwareName: $equityManagementSoftwareName
        contactPersonName: $contactPersonName
        contactPersonEmail: $contactPersonEmail
        contactPersonJobTitle: $contactPersonJobTitle
      }
    ) {
      equityPlan {
        id
      }
      errors
    }
  }
`

const UPDATE_EQUITY_COMPANY_PLAN_QUERY = gql`
  mutation UpdateEquityCompanyPlan(
    $companyId: ID!
    $equityPlanId: ID!
    $planName: String
    $grantorName: String
    $vestingScheduleMonths: Int
    $vestingCliffMonths: Int
    $vestingCliffShares: Float
    $equityManagementSoftwareName: [String!]
    $contactPersonName: String
    $contactPersonEmail: String
    $contactPersonJobTitle: String
  ) {
    equityUpdateCompanyPlan(
      input: {
        companyId: $companyId
        equityPlanId: $equityPlanId
        planName: $planName
        grantorName: $grantorName
        vestingScheduleMonths: $vestingScheduleMonths
        vestingCliffMonths: $vestingCliffMonths
        vestingCliffShares: $vestingCliffShares
        equityManagementSoftwareName: $equityManagementSoftwareName
        contactPersonName: $contactPersonName
        contactPersonEmail: $contactPersonEmail
        contactPersonJobTitle: $contactPersonJobTitle
      }
    ) {
      equityPlan {
        id
      }
      errors
    }
  }
`

export const useCreateEquityCompanyPlan = (options?: InjectedOptions) =>
  useMutation(CREATE_EQUITY_COMPANY_PLAN_QUERY, {
    refetchQueries: [GENERAL_STAFF_GET_CUSTOMER_EQUITY_TAB],
    ...options,
  })

export const useUpdateEquityCompanyPlan = (options?: InjectedOptions) =>
  useMutation(UPDATE_EQUITY_COMPANY_PLAN_QUERY, {
    refetchQueries: [GENERAL_STAFF_GET_CUSTOMER_EQUITY_TAB],
    ...options,
  })
